import { render, staticRenderFns } from "./lantern-enroll.vue?vue&type=template&id=a962dfd2&"
import script from "./lantern-enroll.vue?vue&type=script&lang=ts&"
export * from "./lantern-enroll.vue?vue&type=script&lang=ts&"
import style0 from "./lantern-enroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports